import React from "react";
import { ReactComponent as Logo } from "assets/icons/logo.svg";
import { Avatar } from "@appsmith/ads";
import { Container, UserNameWrapper, UserInformation } from "./Topbar.styles";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "actions/UserActions";
import {
  Flex,
  Menu,
  MenuItem,
  MenuContent,
  MenuTrigger,
  MenuSeparator,
  Text,
} from "@appsmith/ads";
import { getUserDetails } from "selectors/UserSelectors";
import { useNavigate } from "react-router-dom";
import {
  SIGN_OUT_TEXT,
  YOUR_ACCOUNT_TEXT,
  ACCOUNT_SETTINGS_TITLE,
  createMessage,
} from "constants/Messages";
import { ACCOUNT_SETTINGS, LICENSE } from "constants/RouteContants";
import {
  endSupportAccessSession,
  getSupportAccessSession,
} from "utils/SupportAccessUtils";

function Topbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(getUserDetails);
  const supportAccessSession = getSupportAccessSession();

  const handleLogout = async () => {
    // Best-effort revoke of any delegated token before clearing the session.
    await endSupportAccessSession();
    dispatch(logoutUser());
  };

  const handleExitSupportAccess = async () => {
    // Best-effort revoke of the delegated token before clearing the session.
    await endSupportAccessSession();
    // Full reload clears customer-scoped Redux state from the delegated
    // session. Must land on a whitelisted Auth0 callback route —
    // /support-access is not one, and reloading there hangs the auth loader.
    window.location.assign(LICENSE);
  };

  const Profile = () => (
    <Avatar
      className="cursor-pointer"
      data-testid="avatar-container"
      firstLetter={user?.name ? user.name?.toUpperCase().slice(0, 2) : "UN"}
      label={createMessage(YOUR_ACCOUNT_TEXT)}
    />
  );

  return (
    <Container>
      <Logo
        className="topbar-logo"
        data-testid="appsmith-logo"
        onClick={() => navigate("/")}
      />
      <Flex alignItems="center" gap="spaces-3">
        {supportAccessSession && (
          <Text kind="body-s">
            Supporting {supportAccessSession.subjectEmail}
          </Text>
        )}
        <Menu>
          <MenuTrigger>{Profile()}</MenuTrigger>
          <MenuContent align="end">
            <UserInformation>
              <Profile />
              <UserNameWrapper>
                <div className="user-username">
                  <Text kind="body-s">{user?.email || ""}</Text>
                </div>
              </UserNameWrapper>
            </UserInformation>
            <MenuSeparator />
            <MenuItem
              onSelect={() => navigate(ACCOUNT_SETTINGS)}
              startIcon="settings-2-line"
            >
              {createMessage(ACCOUNT_SETTINGS_TITLE)}
            </MenuItem>
            {supportAccessSession && (
              <>
                <MenuItem onSelect={handleExitSupportAccess} startIcon="logout">
                  Exit support access
                </MenuItem>
                <MenuSeparator />
              </>
            )}
            <MenuItem
              className="t--logout-icon signout-option"
              onSelect={handleLogout}
              startIcon="logout"
            >
              {createMessage(SIGN_OUT_TEXT)}
            </MenuItem>
          </MenuContent>
        </Menu>
      </Flex>
    </Container>
  );
}

export default Topbar;
